<sm-title-bar pageTitle="Unavailability" [pageSubTitle]="serviceType == '0' ? 'For Home Services' : (serviceType == '1' ? 'For Shop Services' : 'For Virtual Services')" [back]="true" [headerCustomTemplate]="addButton">
    <ng-template #addButton>
      <!-- settings -->
      <!-- <div class="create_btn_sd">
        <button mat-icon-button color="primary" aria-label="Add Document" (click)="openModal()">
          <mat-icon >add</mat-icon>
        </button>
    </div> -->

    <div class="employe_btn d-flex search-field" >
      <button mat-flat-button color="accent"  (click)="openModal()">
        <mat-icon class="material-icons-round" [inline]="true"
        >add</mat-icon>
        Add date
      </button>
    </div>

    </ng-template>
  </sm-title-bar>

  <div class="entity_unavailability" *ngIf="!loader && unavailabilityData.length > 0">
  <div class="body_services" *ngFor="let item of unavailabilityData">
    <div class="or_nxt">
      <div class="option_mn">
        <button mat-icon-button [matMenuTriggerFor]="homeMenu1">
          <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #homeMenu1="matMenu">
  
        <!-- <button mat-menu-item> <mat-icon class="material-icons-outlined" >add</mat-icon> Add more</button> -->
        <button mat-menu-item (click)="deleteData(item)"> <mat-icon class="material-icons-outlined" >delete</mat-icon>Delete</button>
       </mat-menu>
      </div>
    <div class="day_sp">
      <p class="fun_bt days_t">{{item.unavailability_date | date}}</p>
    </div>
    <div class="day_sp">
      <p class="fromtext">{{tConv24(item.from_time)}} - {{tConv24(item.to_time)}}</p>
    </div>
    <div class="day_sp">
      <p class="fromtext"> {{item.notes && item.notes != 'null' && item.notes != '' ? item.notes : '---'}}</p>
    </div>
  </div>


   </div>



  </div>

   <!-- placeholdr section start -->
    <div class="row" *ngIf="!loader && unavailabilityData.length == 0">
      <div class="col-sm-12">
        <div class="notif-empty">
          <div class="notif-empty-content">
            <div class="notif-icon">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g data-name="15 Chat"><path d="M272.57 165.56H25a25 25 0 0 1 0-50h247.6a25 25 0 0 1 0 50zM487 165.56h-62.58a25 25 0 0 1 0-50H487a25 25 0 0 1 0 50zM487 396.44H239.43a25 25 0 0 1 0-50H487a25 25 0 0 1 0 50zM87.58 396.44H25a25 25 0 0 1 0-50h62.58a25 25 0 0 1 0 50z" fill="#969696" opacity="1" data-original="#000000" class=""></path><path d="M163.51 470.52a100.93 100.93 0 1 1 100.92-100.93 101 101 0 0 1-100.92 100.93zm0-151.85a50.93 50.93 0 1 0 50.92 50.92 51 51 0 0 0-50.92-50.92zM348.49 241.49a100.93 100.93 0 1 1 100.93-100.93 101 101 0 0 1-100.93 100.93zm0-151.85a50.93 50.93 0 1 0 50.93 50.92 51 51 0 0 0-50.93-50.92z" fill="#969696" opacity="1" data-original="#000000" class=""></path></g></g></svg>
            </div>
          <div class="notif-empty-text">
            <h3>No unavailability data</h3>
            <p> There's no information of any {{serviceType == '0' ? 'home' : (serviceType == '1' ? 'shop' : 'virtual')}} service unavailability for today or in future. You can set one with the plus (+) button top right. </p>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- placeholdr section end -->
  

